<template>
	<div class="xxzy-main">
		<div style="width: 600px; margin: 0 auto;">
			<img src="../../../static/building_no_word.jpg" style="height: 100%; width: 100%;" alt="">
			<div style="font-size: 30px; color: darkblue; height: 100px;">
				The page is under construction, stay tuned.
			</div>
		</div>
	</div>
</template>

<script>
	import Page from '@/components/Page.vue'
	export default {
		name: '',
		components: {
			Page,
		},
		data() {
			return {
				
			}
		},
		mounted() {
			let that = this
			that.$store.state.showTopImage = true
			that.$store.state.topImage = '../../static/top_banner_4.png'
		},
		methods: {
			
		}
	}
</script>

<style lang="less" scoped>
	.xxzy-main {
		width: 600px;
		margin: 30px auto 40px;
	}
</style>



// WEBPACK FOOTER //
// src/views/education/earningresource.vue